/**
 * 큰 제목의 반응형 글자 크기.
 *
 * Admin에서 정한 값은 **일반적인 데스크톱(폭 1000px 이상)에서 실제로 보이는 크기**이고,
 * 화면이 좁아지면 화면 폭에 비례해 줄어들다가 절반에서 멈춘다.
 *
 * 중간 구간의 계수를 `maxPx / 10` 으로 두면 화면 폭이 정확히 1000px일 때 maxPx가 된다.
 * 원래 디자인값(Hero 7vw→68px, Contact 6vw→60px)이 이 규칙에서 그대로 나오므로
 * 섹션마다 계수를 따로 관리할 필요가 없다.
 *
 * 계수를 고정값으로 두면 안 된다 — 예를 들어 6vw로 고정한 채 Admin에서 96px을 넣으면
 * 폭 1440px 화면에서 86px밖에 안 나와서, 설정한 값과 실제 화면이 어긋난다.
 *
 * @param maxPx 데스크톱에서의 크기 (Admin 설정값)
 */
export function fluidHeadingSize(maxPx: number): string {
  return `clamp(${Math.round(maxPx / 2)}px, ${(maxPx / 10).toFixed(1)}vw, ${maxPx}px)`
}

/** 좁은 화면에서 실제로 줄어드는 최소 크기 — Admin 안내 문구에 쓴다 */
export function minHeadingSize(maxPx: number): number {
  return Math.round(maxPx / 2)
}
